import React from "react";
//import "./App.css";
import "./App.scss";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Card from "./components/Card";
//import dzenData from "./dzenData";
//import telegramData from "./telegramData";

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      //    loading: false,
      dzen: [],
      telegram: [],
      instagram: [],
      youtube: [],
      hashtag: {},
    };
    this.globalUrlAPI = "https://gravitsappa-test.000webhostapp.com/api/v1/";
    //this.globalUrlAPI = "http://localhost/gravitsappa/build/api/v1/";
    this.loadAllData = this.loadAllData.bind(this);
    this.resetDB = this.resetDB.bind(this);
    this.getAPIData = this.getAPIData.bind(this);
  }

  getAPIData(request) {
    let url = this.globalUrlAPI + request;
    let resultPromise = fetch(url)
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          [request]: data,
        });
        return data;
      });
    return resultPromise;
  }

  resetDB() {
    let url = this.globalUrlAPI + "reset";
    console.log(url);
    fetch(url)
    .then((resp) => {      
      console.log("DB reseted");
      this.loadAllData(); // TODO: есть подозрение, что обновляется слишком много компонентов в сравнении со стартом страницы!      
      return resp;
    })    
  }

  loadAllData() {
    Promise.all([
      this.getAPIData("dzen"),
      this.getAPIData("telegram"),
      this.getAPIData("instagram"),
      this.getAPIData("youtube")
    ])
      .then((results) => console.log(results))
      .then(() => this.getAPIData("hashtag"))
      .then(() => console.log("state: ", this.state));
  }

  componentDidMount() {
    this.loadAllData();
  }

  render() {
    const dzenCards = this.state.dzen.map((card) => (
      <Card key={card.id} card_data={card} />
    ));
    const telegramCards = this.state.telegram.map((card) => (
      <Card key={card.id} card_data={card} />
    ));
    const instagramCards = this.state.instagram.map((card) => (
      <Card key={card.id} card_data={card} />
    ));
    const youtubeCards = this.state.youtube.map((card) => (
      <Card key={card.id} card_data={card} />
    ));

    return (
      <div className="App">
        <Header hashtag={this.state.hashtag} reset={this.resetDB} />
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >          
          {telegramCards}
          {instagramCards}
          {youtubeCards}
          {dzenCards}
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;
